@import 'styles/mixins';

.shimmererContainer {
  overflow: hidden;
  position: relative;
}

.shimmerer {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.075);

  &.isOverlay {
    background-color: rgba(255, 255, 255, 0.075);
  }

  &::before {
    content: '';
    z-index: 10;
    position: absolute;
    height: 100%;
    width: 200%;
    top: 0;
    left: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.1) 18%,
      rgba(255, 255, 255, 0.5) 35%,
      rgba(255, 255, 255, 0.1) 51%,
      rgba(255, 255, 255, 0.5) 69%,
      rgba(255, 255, 255, 0.1) 84%,
      transparent 100%
    );
    transform: skewX(-45deg) translateX(-140%);
    animation: shine 2s infinite forwards;
  }
}
@keyframes shine {
  0% {
    transform: skewX(-45deg) translateX(-120%);
  }
  100% {
    transform: skewX(-45deg) translateX(100%);
  }
}
